import { render, staticRenderFns } from "./OwnerEmailNotificationFormBookingModification.vue?vue&type=template&id=380b8175&"
import script from "./OwnerEmailNotificationFormBookingModification.vue?vue&type=script&lang=js&"
export * from "./OwnerEmailNotificationFormBookingModification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports